import { Component, Input, OnInit } from '@angular/core';
import { CardComponent } from '../card/card.component';

@Component({
  selector: 'small-card',
  templateUrl: './small-card.component.html',
  styleUrls: ['./small-card.component.scss'],
  standalone: false,
})
export class SmallCardComponent extends CardComponent implements OnInit {
  @Input() image;
  @Input() mode = 'potrait';
  @Input() tag: string;
  template = 'external';

  ngOnInit() {
    if (this.to && this.to.trim().search(/(http|https):/) !== 0) {
      this.template = 'internal';
    }
  }
}